import React from 'react';
import { Instructions } from '../Instructions';
import UI from '../../ui';

const { DimensionsFieldWithLabel, WeightFieldWithLabel, WrappedButton, WrappedButtonType } = UI;

const ShippingEstimationItem = ({
	boxItem,
	isMobile,
	boxItemIndex,
	onActionTrigger,
	cloneBoxItem,
	onDeleteButtonClick,
	updateInstructions,
	boxesValidation,
}) => {
	const { pounds, ounces, length, width, height } = boxItem;
	const weight = { pounds, ounces };
	const dimensions = { length, width, height };
	const rowNumber = boxItemIndex + 1;
	const boxesValidations = boxesValidation[boxItemIndex];

	const onChangeWeight = updatedWeight => {
		onActionTrigger(updatedWeight, boxItemIndex);
	};

	const onChangeDimensions = updatedDimensions => {
		onActionTrigger(updatedDimensions, boxItemIndex);
	};

	const onClone = () => {
		cloneBoxItem(boxItemIndex);
	};

	const onDelete = () => {
		onDeleteButtonClick(boxItemIndex);
	};

	const onInputFocus = e => {
		const { name } = e.target;
		let instructions = '',
			header = '';

		if (name === 'pounds' || name === 'ounces') {
			header = Instructions.headers.shipping.weight;
			instructions = Instructions.instructions.shipping.weight;
		} else if (name === 'length' || name === 'width' || name === 'height') {
			header = Instructions.headers.shipping.dimensions;
			instructions = Instructions.instructions.shipping.dimensions;
		}

		updateInstructions('shipping', header, instructions);
	};

	return (
		<div className="p-grid p-col-12 box-item">
			<div className={`${isMobile ? '' : 'p-md-2 p-lg-1'} box-number`}>{rowNumber}</div>
			{isMobile && (
				<div className="p-grid p-col-12 p-dir-col mobile-wrapper">
					<div className="p-col p-col-align-end buttons-container">
						<div>
							<WrappedButton
								className="clone-box-item"
								buttonType={WrappedButtonType.Icon}
								icon="clone-icon"
								onClick={onClone}
								dataqa="box-item-clone"
							/>
						</div>

						<div>
							<WrappedButton
								buttonType={WrappedButtonType.Icon}
								icon="delete-icon"
								className="delete-box-item"
								onClick={onDelete}
								dataqa="box-item-delete"
							/>
						</div>
					</div>
				</div>
			)}
			<div className="weight p-md-4 p-lg-4">
				<WeightFieldWithLabel
					label={isMobile ? 'Weight' : ''}
					className={boxesValidations.isWeightInvalid ? 'invalid' : ''}
					errorMessage={boxesValidations.weightErrorLabel}
					isInputInvalid={boxesValidations.isWeightInvalid}
					uiElementConfig={{
						weight,
						onChange: onChangeWeight,
						doValidation: false,
						onFocus: onInputFocus,
					}}
				/>
			</div>
			<div className="dimensions p-md-4 p-lg-5">
				<DimensionsFieldWithLabel
					label={isMobile ? 'Dims' : ''}
					className={boxesValidations.isDimensionsInvalid ? 'invalid' : ''}
					errorMessage={boxesValidations.dimensionsErrorLabel}
					isInputInvalid={boxesValidations.isDimensionsInvalid}
					uiElementConfig={{
						dimensions,
						onChange: onChangeDimensions,
						doValidation: false,
						onFocus: onInputFocus,
					}}
				/>
			</div>
			{!isMobile && (
				<div className="p-grid p-md-2 p-lg-2">
					<div className="p-md-6 p-lg-6">
						<WrappedButton
							className="clone-box-item"
							buttonType={WrappedButtonType.Icon}
							icon="clone-icon"
							onClick={onClone}
							dataqa="box-item-clone"
						/>
					</div>

					<div className="p-md-6 p-lg-6">
						<WrappedButton
							buttonType={WrappedButtonType.Icon}
							icon="delete-icon"
							className="delete-box-item"
							onClick={onDelete}
							dataqa="box-item-delete"
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default ShippingEstimationItem;
